import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import { Field, Fields, reduxForm, getFormValues } from 'redux-form';

import MultiselectAutosuggestField from 'components/fields/MultiselectAutosuggestField';
import CheckboxButtonField from 'components/fields/CheckboxButtonField';
import DateRangeFields from 'components/fields/DateRangeFields';

const styles = () => ({
  gridItemShrink: {
    flexShrink: 1,
    minWidth: 0,
  },
  gridContainerCategories: {
    marginBottom: 16,
  },
});

function onChange(values, dispatch, props) {
  if (values['Selected Notes Category']) {
    if (!values['Notes Category']
      || values['Notes Category'].findIndex(item =>
        item.value === values['Selected Notes Category'].value) === -1) {
      props.array.push('Notes Category', values['Selected Notes Category']);
    }
    props.clearFields(false, false, 'Selected Notes Category');
  }
  if (values['Selected Author']) {
    if (!values.Author
      || values.Author.findIndex(item =>
        item.value === values['Selected Author'].value) === -1) {
      props.array.push('Author', values['Selected Author']);
    }
    props.clearFields(false, false, 'Selected Author');
  }
}

const NotesFilterForm = ({
  handleSubmit,
  change,
  actions,
  className,
  formValues,
  filterInputRef,
  filterOptions,
  theme,
  classes,
}) => (
  <form
    className={className}
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
  >
    <Grid
      className={classes.gridContainerCategories}
      container
      spacing={0}
    >
      <Grid item>
        <Field
          id="Intake"
          name="Intake"
          label="Intake"
          color={theme.palette.states.intake}
          component={CheckboxButtonField}
          size="small"
        />
      </Grid>
      <Grid item>
        <Field
          id="Delivery"
          name="Delivery"
          label="Delivery"
          color={theme.palette.states.delivery}
          component={CheckboxButtonField}
          size="small"
        />
      </Grid>
      <Grid item>
        <Field
          id="Billing"
          name="Billing"
          label="Billing"
          color={theme.palette.states.billing}
          component={CheckboxButtonField}
          size="small"
        />
      </Grid>
      <Grid item>
        <Field
          id="Collection"
          name="Collection"
          label="Collection"
          color={theme.palette.states.collection}
          component={CheckboxButtonField}
          size="small"
        />
      </Grid>
      <Grid item>
        <Field
          id="Paid"
          name="Paid"
          label="Paid"
          color={theme.palette.states.paid}
          component={CheckboxButtonField}
          size="small"
        />
      </Grid>
      <Grid item>
        <Field
          id="General"
          name="General"
          label="General"
          color={theme.palette.states.archive}
          component={CheckboxButtonField}
          size="small"
        />
      </Grid>
    </Grid>
    <Grid
      container
      spacing={24}
      wrap="nowrap"
    >
      <Grid
        item
        xs={6}
      >
        <Fields
          names={[
            'Notes Category Name',
            'Notes Category',
          ]}
          autosuggestFieldName="Notes Category Name"
          fieldArrayName="Notes Category"
          placeholder="-Search by Category-"
          component={MultiselectAutosuggestField}
          renderSuggestionContent={suggestion =>
            suggestion.Name}
          renderInputContent={suggestion =>
            suggestion.Name}
          onSuggestionSelected={(suggestion) => {
            change('Selected Notes Category', {
              value: suggestion.ID,
              label: suggestion.Name,
            });
            return '';
          }}
          fetchSuggestions={({ value, offset, fieldArrayValue }) => (new Promise((resolve) => {
            const remainingOptions = fieldArrayValue.length > 0
              ? filterOptions['Notes Category']
                  .filter(item => fieldArrayValue.findIndex(arrayItem => arrayItem.value === item.ID) === -1)
              : filterOptions['Notes Category'];
            if (offset === 0) {
              if (value.length > 0) {
                resolve(remainingOptions
                  .filter(item => item.Name.toLowerCase().indexOf(value.toLowerCase()) !== -1));
              } else {
                resolve(remainingOptions);
              }
            } else {
              resolve([]);
            }
          }))}
          keepOpenAfterSelection
          textFieldRef={filterInputRef}
          listWidth="auto"
        />
      </Grid>
      <Grid
        className={classes.gridItemShrink}
        item
        xs={5}
      >
        <Fields
          names={[
            'Author Name',
            'Author',
          ]}
          autosuggestFieldName="Author Name"
          fieldArrayName="Author"
          placeholder="-Author-"
          component={MultiselectAutosuggestField}
          renderSuggestionContent={suggestion =>
            `${suggestion['First Name']} ${suggestion['Last Name']}`}
          renderInputContent={suggestion =>
            `${suggestion['First Name']} ${suggestion['Last Name']}`}
          onSuggestionSelected={(suggestion) => {
            change('Selected Author', {
              value: suggestion.ID,
              label: `${suggestion['First Name']} ${suggestion['Last Name']}`,
            });
            return '';
          }}
          fetchSuggestions={({ value, offset, fieldArrayValue }) => (new Promise((resolve) => {
            const remainingOptions = fieldArrayValue.length > 0
              ? filterOptions.Author
                  .filter(item => fieldArrayValue.findIndex(arrayItem => arrayItem.value === item.ID) === -1)
              : filterOptions.Author;
            if (offset === 0) {
              if (value.length > 0) {
                resolve(remainingOptions
                  .filter(item => `${item['First Name'].toLowerCase()} ${item['Last Name'].toLowerCase()}`
                    .indexOf(value.toLowerCase()) !== -1));
              } else {
                resolve(remainingOptions);
              }
            } else {
              resolve([]);
            }
          }))}
          keepOpenAfterSelection
          textFieldRef={filterInputRef}
          listWidth="auto-right"
        />
      </Grid>
      <Grid
        item
      >
        <Fields
          id="Date of Creation"
          names={[
            'Date of Creation From',
            'Date of Creation To',
          ]}
          placement="bottom-right"
          datepickerPlacement="middle-right"
          placeholder={formValues && formValues['Date of Creation From']
            ? `${formValues['Date of Creation From']}-${formValues['Date of Creation To']}` : 'Date'}
          component={DateRangeFields}
          variant="icon"
          fullWidth
          size="lg"
          valueInLabel
        />
      </Grid>
    </Grid>
  </form>
);

NotesFilterForm.propTypes = {
  className: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  filterInputRef: PropTypes.func,
  theme: PropTypes.shape({
    palette: PropTypes.shape({
      states: PropTypes.shape({
        intake: PropTypes.string.isRequired,
        delivery: PropTypes.string.isRequired,
        billing: PropTypes.string.isRequired,
        collection: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

NotesFilterForm.defaultProps = {
  onCancelButtonClick: () => {},
  initialValues: {},
  error: null,
  onSubmitButtonBlur: () => {},
  inputRef: () => {},
  onSubmitButtonClick: () => {},
  className: '',
  filterInputRef: () => {},
};

const mapStateToProps = (store, ownProps) => ({
  formValues: getFormValues(ownProps.form)(store),
});

export default connect(mapStateToProps)(
  reduxForm({
    onChange,
  })(withStyles(styles, { withTheme: true })(NotesFilterForm)),
);



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/Notes/NotesFilterForm.js